/**
 * Every room the lodge can assign. Rooms 1-8 are single rooms with two beds,
 * room 9 has three beds, and 10 and 11 are family units with three bedrooms.
 */
export type Room = { id: string; label: string; detail: string; sleeps: number }

export const ROOMS: Room[] = [
  ...Array.from({ length: 8 }, (_, i) => ({
    id: String(i + 1),
    label: `Room ${i + 1}`,
    detail: '2 beds',
    sleeps: 2,
  })),
  { id: '9', label: 'Room 9', detail: '3 beds', sleeps: 3 },
  { id: '10', label: 'Unit 10', detail: 'Family unit · 3 bedrooms', sleeps: 6 },
  { id: '11', label: 'Unit 11', detail: 'Family unit · 3 bedrooms', sleeps: 6 },
]

export const ROOM_IDS = ROOMS.map((r) => r.id)

export function roomLabel(id: string) {
  return ROOMS.find((r) => r.id === id)?.label ?? `Room ${id}`
}
